import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../SectionTitle/SectionTitle';
import Services from "../../api/Services";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ServiceSectionS3 = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <div className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <SectionTitle subtitle={'Trusted transport service'} title={'Transport & Logistics Services We are the best'} />
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="service-btn">
                            <Link onClick={ClickHandler} to="/services" className="theme-btn">All Services</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid'>
                <div className="row mt-5">
                    {Services.slice(0, 3).map((service, item) => (
                        <div className="col-md-4">
                            <div className="service-card" key={item}>
                                <div className="servic-image">
                                    <img className="image" src={service.image} alt="" />
                                </div>
                                <div className="content pt-4">
                                    {/* <i className={service.iconName}></i> */}
                                    <div className="text">
                                        <span>{service.id}</span>
                                        <h2><Link to={`/services/${service.slug}`} onClick={ClickHandler}>{service.title}</Link></h2>
                                        <p>{service.description}</p>
                                        <Link to={`/services/${service.slug}`} onClick={ClickHandler} className="service-single-link">
                                            <i className="flaticon-right-arrow"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* <div className="service-slider-s2">
                <Slider {...settings} className="service-slider">
                    {Services.slice(0, 9).map((service, item) => (
                        <div className="service-card" key={item}>
                            <img className="image" src={service.image} alt="" />
                            <div className="content">
                                <i className={service.iconName}></i>
                                <div className="text">
                                    <span>{service.id}</span>
                                    <h2><Link to={`/service-single/${service.slug}`} onClick={ClickHandler}>{service.title}</Link></h2>
                                    <p>{service.description}</p>
                                    <Link to={`/service-single/${service.slug}`} onClick={ClickHandler} className="service-single-link">
                                        <i className="flaticon-right-arrow"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div> */}
        </div>
    );
};

export default ServiceSectionS3;